import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  root: {
    display: 'block',
    width: '100%',
    minHeight: '100vh',
    background: 'rgba(67, 70, 137, 1)',
    backdropFilter: 'blur(52.201263427734375px)',
    backgroundSize: 'cover',
    '& img': {
      display: 'block',
      width: '100%',
      height: 'auto',
      objectFit: 'contain',
    },
  },
}));
